import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {OEMediaCenterItemTypes, OEMediaCenterMode, OEMediaCenterModeBottomBarLayoutType, OEMediaCenterPropTypes, OEMediaCenterConfigFactory} from '../oe-media-center-model';
import OEMediaCenterItemCollectionController from '../oe-media-center-item-collection-controller';
import OEMediaCenterControlBarPanel from './oe-media-center-control-bar-panel';
import OESlider from '../../../elements/controls/oe-slider';
import OEAnimationControl from '../../../animation-control/oe-animation-control';
import OEPresentationSlideList from '../../presentation/oe-presentation-slide-list';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OEAnimateHelper from '../../../../lib/animation/oe-animate-helper';
import retardUpdate from '../../../../lib/react/update-retarder';

export default class OEMediaCenterBottomBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.controlState = this.determineControlState(false);
        
        this.presSlidePreviewSize = {w: 0, h: 0};
        this.bottomBarSize = {w: 0, h: 0};
        this.layoutSize = {w: 0, h: 0};

        this.edgeOffsets = this.determineEdgeOffsets(false);
        this.maxEdgeOffsets = this.determineMaxEdgeOffsets(false);

        this.state = Object.assign({
            edgeOffsets: clone(this.edgeOffsets),
            presSlidePreviewSize: clone(this.presSlidePreviewSize),
            ...this.controlState
        });

        //this.onWindowResized = this.onWindowResized.bind(this);

        this.onBottomBarResize = this.onBottomBarResize.bind(this);
        this.onPresSlidePreviewResize = this.onPresSlidePreviewResize.bind(this);
        this.onLayoutResize = this.onLayoutResize.bind(this);
    }

    getEdgeOffsets()    {
        return clone(this.edgeOffsets);
    }

    getMaxEdgeOffsets()    {
        return clone(this.maxEdgeOffsets);
    }

    /*
    componentDidMount()    {
        this.updateEdgeOffsets(false);
        window.addEventListener('resize', this.onWindowResized);
    }

    componentWillUnmount()    {
        this.updateEdgeOffsets(false);
        window.removeEventListener('resize', this.onWindowResized);
    }
    */

    componentWillReceiveProps(nextProps) {
        let configPlayModeBlurringChanged = !OEToolbox.shallowEqual(nextProps.config, this.props.config, true) || nextProps.playMode != this.props.playMode || nextProps.blurring != this.props.blurring;

        if(nextProps.item != this.props.item || configPlayModeBlurringChanged)   {
            retardUpdate(this, () => {
                this.updateControlState(configPlayModeBlurringChanged, nextProps);
                this.setState({animateVisibility: !nextProps.item || !this.props.item || nextProps.item.sliderConfig.visible == this.props.item.sliderConfig.visible});
            });
        }

        if(nextProps.visible != this.props.visible)   {
            retardUpdate(this, () => {
                this.updateEdgeOffsets(true, nextProps);
                this.setState({animateVisibility: true});
            });
        }
    }

    /*
    onWindowResized()   {
        this.updateEdgeOffsets(false);
    }
    */
   
    determineEdgeOffsets(animated = true, props)   {
        props = props || this.props;
        let edgeOffsets = {bottom: 0, animate: {bottom: animated}};

        if(props.visible)    {
            edgeOffsets.bottom = !this.controlState.hide ? this.bottomBarSize.h : (this.controlState.showPresSlidePreview ? this.presSlidePreviewSize.h : 0);
        }

        return edgeOffsets;
    }

    determineMaxEdgeOffsets(animated = true, props)   {
        return {bottom: Math.max(this.layoutSize.h, this.bottomBarSize.h), animate: {bottom: animated}};
    }

    determineControlState(animated = true, props)    {
        props = props || this.props;
        const config = props.config;

        let mediaItem = props.item;
        let itemType = mediaItem ? mediaItem.type : OEMediaCenterItemTypes.none;

        let isPresentation = itemType === OEMediaCenterItemTypes.presentation;

        let newState = {
            hide: false,
            animateVisibility: animated,
            hasPresSlidePreview: isPresentation,
            showPresSlidePreview: isPresentation && (props.playMode || !config.presPreviewOnlyInPlayMode) && !config.noPresPreview,
            showAnimationControl: config.hideBottomBarControlsForItems.findIndex((type) => type === itemType) < 0,
            slider: {visible: false, enabled: false}
        };

        if(mediaItem)   {
            let sliderConfig = mediaItem.sliderConfig;

            newState.slider = {
                visible: sliderConfig.visible && config.hideSliderForItems.findIndex((type) => type === itemType) < 0,
                enabled: sliderConfig.enabled
            };

            if(itemType === OEMediaCenterItemTypes.animation || itemType === OEMediaCenterItemTypes.presentation) {
                newState.hide = config.bigPlayBtn && ((!props.playMode && props.blurring) || (props.playMode && (isPresentation && !newState.slider.visible)));
            }

            if(itemType === OEMediaCenterItemTypes.presentation && config.bigPlayBtn) {
                newState.slider.visible = newState.slider.visible && sliderConfig.enabled;
            }

            if(itemType === OEMediaCenterItemTypes.animation || itemType === OEMediaCenterItemTypes.presentation) {
                newState.slider.visible = newState.slider.visible && !newState.hide;        // prevents that the slider is shortly visible if hidden but slider gets visible=true state
            }
        }

        return newState;
    }

    updateEdgeOffsets(animated = true, props)  {
        props = props || this.props;

        let edgeOffsets = this.determineEdgeOffsets(animated, props);

        if(!OEToolbox.shallowEqual(edgeOffsets, this.edgeOffsets, true)) {
            this.edgeOffsets = edgeOffsets;
            this.setState({edgeOffsets: clone(this.edgeOffsets)});
            if(props.onEdgeOffsetsChanged)  props.onEdgeOffsetsChanged(edgeOffsets);
        }
    }

    updateMaxEdgeOffsets(animated = true, props)  {
        props = props || this.props;

        let maxEdgeOffsets = this.determineMaxEdgeOffsets(animated, props);

        if(!OEToolbox.shallowEqual(maxEdgeOffsets, this.maxEdgeOffsets, true)) {
            this.maxEdgeOffsets = maxEdgeOffsets;
            if(props.onMaxEdgeOffsetsChanged)  props.onMaxEdgeOffsetsChanged(maxEdgeOffsets);
        }
    }

    updateControlState(animated = true, props)    {
        let newState = this.determineControlState(animated, props);

        if(OEToolbox.shallowEqual(newState, this.controlState, true))   return;

        this.controlState = newState;
        this.setState({...this.controlState});

        this.updateEdgeOffsets(animated, props);
    }

    onBottomBarResize(sender, size)  {
        if(OEToolbox.shallowEqual(size, this.bottomBarSize))   return;
        let heightChanged = size.h != this.bottomBarSize.h;
        this.bottomBarSize = {w: size.w, h: size.h};
        if(heightChanged)   {
            this.updateEdgeOffsets(false);
            this.updateMaxEdgeOffsets(false);
        }
    }

    onPresSlidePreviewResize(size)  {
        if(OEToolbox.shallowEqual(size,  this.presSlidePreviewSize))   return;
        let heightChanged = size.h != this.presSlidePreviewSize.h;
        this.presSlidePreviewSize = {w: size.w, h: size.h};
        this.setState({presSlidePreviewSize: this.presSlidePreviewSize});
        if(heightChanged)   this.updateEdgeOffsets(false);
    }

    onLayoutResize(sender, size)    {
        if(OEToolbox.shallowEqual(size,  this.layoutSize))   return;
        let heightChanged = size.h != this.layoutSize.h;
        this.layoutSize = {w: size.w, h: size.h};
        if(heightChanged)   this.updateMaxEdgeOffsets(false);
    }

    render() {
        const visible = this.props.visible;
        const enabled = this.props.enabled;

        //
        let translateY = 'translateY(100%)';
        if(visible)   {
            if(!this.state.hide)  {
                translateY = 'translateY(0)';
            } else if(this.state.showPresSlidePreview)    {
                const presSlidePreviewHeightStr = this.state.presSlidePreviewSize.h.toString() + 'px';
                translateY = 'translateY(100%) translateY( -' + presSlidePreviewHeightStr + ')';
            }
        }

        let bottomBarStyle = {
            transform: translateY,
            transition: '',
            right: this.props.edgeOffsets && typeof(this.props.edgeOffsets.right) === 'number' ? this.props.edgeOffsets.right.toString() + 'px' : ''
        };

        if(this.state.animateVisibility)    bottomBarStyle.transition = 'transform 0.333s ease';

        if(this.props.edgeOffsets && OEAnimateHelper.animateRight(this.props.edgeOffsets.animate))   {
            if(bottomBarStyle.transition != '')    bottomBarStyle.transition = bottomBarStyle.transition + ', ';
            bottomBarStyle.transition = bottomBarStyle.transition + 'right 0.333s ease';
        }

        //
        return (
            <div
                className={'bottom-bar light-bg ' + this.props.className}
                style={bottomBarStyle}
            >
                <OEResizeObserver onResize={this.onBottomBarResize}/>

                {(!this.state.hide && !this.state.showPresSlidePreview) || (this.state.hide && !this.state.hasPresSlidePreview) || !this.props.item ? null :
                    <OEPresentationSlideList
                        magnificationClassName="media-center-slide-preview-magni-border"
                        moduleId={this.props.moduleId}
                        enabled={enabled}
                        presID={this.props.item.index}
                        onlyPreviewSlides={this.props.onlyPreviewSlides}
                        magnification={3.33}
                        onResize={this.onPresSlidePreviewResize}
                    />
                }

                {this.props.config.mode !== OEMediaCenterMode.bottomBar || this.props.bottomBarModeLayoutType != OEMediaCenterModeBottomBarLayoutType.horizontal ? null :
                    <OEMediaCenterItemCollectionController
                        moduleId={this.props.moduleId}
                        config={{
                            usePresItems: false,
                            presPlayableFlags: this.props.config.presPlayableFlags
                        }}
                        enabled={enabled}
                        magnification={this.props.config.presMagnification}
                        onSelected={this.props.onItemCollectionSelected}
                    />
                }

                {!this.state.slider.visible ? null :
                    <div className="slider-bar">
                        <OESlider
                            disabled={!(enabled && this.state.slider.enabled)}
                            min={0}
                            max={1}
                            step={0.001}
                            value={this.props.progress}
                            onStart={this.props.onProgressSliderChanged}
                            onSlide={this.props.onProgressSliderChanged}
                            onEnd={this.props.onProgressSliderChanged}
                        />
                    </div>
                }

                {!this.state.showAnimationControl ? null :
                    <div className="control-bar d-flex justify-content-between flex-wrap">
                        <div className="left">
                            <OEAnimationControl
                                enabled={enabled && this.props.animationControlEnabled && this.props.playEnabled}
                                slider={{visible: false, enabled: false}}
                                adapter={this.props.adapter}
                                onPlayBtnPressed={this.props.onAnimationControlPlay}
                                onPauseBtnPressed={this.props.onAnimationControlPause}
                                onStopBtnPressed={this.props.onAnimationControlStop}
                            />
                        </div>

                        <div className="flex-grow-1 middle">
                            <OEMediaCenterControlBarPanel moduleId={this.props.moduleId} enabled={enabled} />
                        </div>

                        <div className="right">
                        </div>
                    </div>
                }

                <div className="layout-size-container">
                    <OEResizeObserver onResize={this.onLayoutResize}/>

                    <div className="presentation-slides-view"/>

                    <div className="slider-bar">
                        <OESlider/>
                    </div>
                </div>
            
            </div>
        );
    }
}

OEMediaCenterBottomBar.defaultProps = {
    className: '',
    moduleId: '',
    config: OEMediaCenterPropTypes.defaultBottomBarConfig,
    onlyPreviewSlides: true,
    visible: true,
    enabled: true,
    playEnabled: false,
    animationControlEnabled: false,
    playMode: false,
    blurring: false,
    progress: 0,
    bottomBarModeLayoutType: OEMediaCenterModeBottomBarLayoutType.std
};

OEMediaCenterBottomBar.propTypes = {
    className: PropTypes.string,
    moduleId: PropTypes.string,
    config: OEMediaCenterPropTypes.bottomBarConfigDecl,
    onlyPreviewSlides: PropTypes.bool,
    visible: PropTypes.bool,
    enabled: PropTypes.bool,
    playEnabled: PropTypes.bool,
    animationControlEnabled: PropTypes.bool,
    playMode: PropTypes.bool,
    blurring: PropTypes.bool,
    item: PropTypes.object,
    progress: PropTypes.number,
    adapter: PropTypes.object,
    edgeOffsets: OEAnimateHelper.offsetDecl,
    bottomBarModeLayoutType: PropTypes.oneOf(OEMediaCenterModeBottomBarLayoutType.all),
    onItemCollectionSelected: PropTypes.func,
    onProgressSliderChanged: PropTypes.func,
    onAnimationControlPlay: PropTypes.func,
    onAnimationControlPause: PropTypes.func,
    onAnimationControlStop: PropTypes.func,
    onEdgeOffsetsChanged: PropTypes.func,
    onMaxEdgeOffsetsChanged: PropTypes.func
};